var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-1","x2":"24.0306","y2":"-1","transform":"matrix(0.707362 -0.706851 0.707362 0.706851 5.00146 21.9863)","stroke":"black","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"4.70711","y1":"4.29289","x2":"21.6993","y2":"21.2851","stroke":"black","strokeWidth":"2","key":1})]);
}

MenuClose.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
